// extracted by mini-css-extract-plugin
module.exports = {"list":"ContextStats_tiles_list__36zbg","bg":"ContextStats_tiles_bg__10DbL"};